import { Yield } from '../../abacus/interfaces/yield.interface'

export const lifecycleYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
